<template>
  <img
    width="20px"
    height="20px"
    src="@/assets/icon/spam.svg"
    alt="filterIcon">
</template>

<script>

export default {
  name: 'CoozzySpamIcon'
}
</script>

<style lang="scss" scoped>
</style>
